export const Logo = ({ size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    data-testid="brand-logo-mark"
  >
    <rect x="1.5" y="1.5" width="29" height="29" rx="8.5" stroke="#0F172A" strokeWidth="2" />
    <path d="M16 9.6v2.9M21.5 19.2l-2.7-1.6M10.5 19.2l2.7-1.6" stroke="#0F172A" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="16" cy="15.4" r="3.1" fill="#0D9488" />
    <circle cx="16" cy="7.4" r="1.9" fill="#0F172A" />
    <circle cx="23.6" cy="20.4" r="1.9" fill="#0F172A" />
    <circle cx="8.4" cy="20.4" r="1.9" fill="#0F172A" />
  </svg>
);
